import {
  FETCH_AUDITTRAILLIST_REQUEST,
  FETCH_AUDITTRAILLIST_SUCCESS,
  FETCH_AUDITTRAILLIST_FAILURE,
} from "./inventoryAuditTrailTypes";
import api from "../../utils/Api";
import axios from 'axios';

export const fetchAuditTrailListRequest = () => {
  return {
    type: FETCH_AUDITTRAILLIST_REQUEST,
  };
};

export const fetchAuditTrailListSuccess = (AuditTrailList) => {
  return {
    type: FETCH_AUDITTRAILLIST_SUCCESS,
    payload: AuditTrailList,
  };
};

export const fetchAuditTrailListFailure = (error) => {
  return {
    type: FETCH_AUDITTRAILLIST_FAILURE,
    payload: error,
  };
};

const CancelToken = axios.CancelToken;
let cancelRequest;
export const fetchAuditTrailList = (searchKey, sortBy, page) => {
   //cancel previous request if multiple hits done.
   cancelRequest && cancelRequest();
  const headers = {
    Authorization:
      "Bearer " + JSON.parse(localStorage.getItem("USER_INFO")).token,
  };
  let url = "inventory/inventorylog/fetch?search_key=" + searchKey + "&sort_by=" + sortBy + "&page=" + page
  return async (dispatch) => {
    dispatch(fetchAuditTrailListRequest);
    try {
      const response = await api.get(url, {
        headers: headers,
        cancelToken: new CancelToken(function executor(c) {
          cancelRequest = c;
      })
      });
      const AuditTrailList = response.data.data;
     // console.log("************AuditTrailList", AuditTrailList);
      dispatch(fetchAuditTrailListSuccess(AuditTrailList));
    } catch (error) {
      if (axios.isCancel(error)) {
        console.log('Error: ', error.message); // => prints: Api is being canceled
      } 
      console.log("Redux error - ", error.response);
      const errorMsg = error.message;
      dispatch(fetchAuditTrailListFailure(errorMsg));
    }
  };
};
